import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import vn from "./locales/vn.json";
import zh from "./locales/zh.json";
import kr from "./locales/kr.json";
import LanguageDetector from "i18next-browser-languagedetector";
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: true,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en,      
      vn,
      zh,
      kr
    },
  });

export default i18n;